<template>
  <nav class="navbar">
    <div class="logo">
      <img src="@/assets/logo.png" alt="logo" style="height:28px;vertical-align:middle;margin-right:6px;">
      龟谷
    </div>
    <ul class="nav-links">
      <li><router-link to="/" :class="{ active: $route.path === '/' }">首页</router-link></li>
      <li><router-link to="/school" :class="{ active: $route.path === '/school' }">龟谷学堂</router-link></li>
      <li><router-link to="/hall" :class="{ active: $route.path === '/hall' }">龟谷大厅</router-link></li>
      <li class="auth-links" v-if="!isLoggedIn">
        <router-link to="/login">登录</router-link>
        <span class="divider">|</span>
        <router-link to="/register">注册</router-link>
      </li>
      <li class="user-info" v-else>
        <div class="user-dropdown" @click="toggleDropdown" ref="dropdownRef">
          <span class="username">{{ username }}</span>
          <span class="dropdown-arrow">▼</span>
          <div class="dropdown-menu" v-show="showDropdown">
            <div class="dropdown-item" @click="handleLogout">
              <span class="logout-icon">🚪</span>
              退出登录
            </div>
          </div>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuth } from '@/composables/useAuth'

const router = useRouter()
const { isLoggedIn, username, logoutUser } = useAuth()

const showDropdown = ref(false)
const dropdownRef = ref(null)

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value
}

const handleLogout = async () => {
  await logoutUser()
  localStorage.removeItem('username');
  showDropdown.value = false
  router.push('/')
}

// 点击外部关闭下拉菜单
const handleClickOutside = (event) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    showDropdown.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 48px;
  background: rgba(10, 24, 60, 0.85);
  z-index: 1000;
  box-sizing: border-box;
}

.logo {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 1.5px;
  margin-left: 100px;
}

.nav-links {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  margin-right: 100px;
}

.nav-links li {
  margin-left: 18px;
}

.nav-links a {
  color: #fff;
  text-decoration: none;
  font-size: 15px;
  transition: color 0.2s;
}

.nav-links a:hover,
.nav-links a.active,
.nav-links a.router-link-exact-active {
  color: #00e0ff;
  font-weight: bold;
}

.auth-links {
  display: flex;
  align-items: center;
}

.divider {
  margin: 0 6px;
  color: #fff;
}

.user-info {
  position: relative;
}

.user-dropdown {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background-color 0.2s;
  position: relative;
}

.user-dropdown:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.username {
  color: #fff;
  font-size: 15px;
  margin-right: 6px;
}

.dropdown-arrow {
  color: #fff;
  font-size: 12px;
  transition: transform 0.2s;
}

.user-dropdown:hover .dropdown-arrow {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 120px;
  z-index: 1000;
  margin-top: 4px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.logout-icon {
  margin-right: 6px;
  font-size: 16px;
}

@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    height: auto;
    padding: 8px 8px;
  }
  
  .nav-links {
    flex-direction: column;
    width: 100%;
    margin-right: 0;
  }
  
  .nav-links li {
    margin: 8px 0 0 0;
  }
  
  .logo {
    margin-left: 0;
  }
  
  .dropdown-menu {
    right: -50px;
  }
}
</style>
